import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { UserSubscriptionWriteDTO } from '../interfaces/userSubscription';

@Injectable({
  providedIn: 'root'
})
export class UserSubscriptionService {

  constructor(private dataService: DataService) { }

  getUserSubscriptions(page: number, size: number) {
    return this.dataService.getUserSubscriptions(page, size);
  }

  getUserSubscriptionNumbers() {
    return this.dataService.getUserSubscriptionNumbers();
  }

  getUserSubscription() {
    return this.dataService.getUserSubscription();
  }

  saveUserSubscription(id: number, userSubscription: UserSubscriptionWriteDTO) {
    if ((id) && (id > 0)) {
      return this.dataService.updateUserSubscription(id, userSubscription);
    } else {
      return this.dataService.createUserSubscription(userSubscription);
    }

  }
}
